/* tslint:disable:component-selector import-spacing no-trailing-whitespace no-inferrable-types typedef-whitespace */
import {
  AfterViewInit,
  Component,
  ViewChild
} from '@angular/core';

import {Logger}                  from '@/util/logger';

import * as $ from 'jquery';
import 'gasparesganga-jquery-loading-overlay';

import {
  BehaviorSubject,
  Subscription
}                                from 'rxjs';

import {ServiceManager}          from "@/services/service.manager";
import {DocumentWindowManager}   from "@/screens/ide/document.window.manager";
import {BatchViewerWindow}       from "@/screens/ide/batch.viewer.window";
import {WindowType}              from "@/screens/ide/window";
import {DocumentWindow}          from "@/screens/ide/document.window";

import {BatchViewer}             from "@/screens/ide/batchviewer/batch.viewer";
import {BatchViewerMetadata}     from "@/screens/ide/batch.viewer.metadata";

@Component({
  selector: 'batch-viewer-component',
  template: `

    <!-- outer shell for batch viewer -->
    <div class="batch-viewer-shell" style="text-align:center">
      <batch-viewer
        uuid={{u}} id="bv_{{u}}"
        (ready)="viewReady($event);"
      >

      </batch-viewer>
    </div>
  `
})

export class BatchViewerComponent implements AfterViewInit {

  /* for uniq'ifying our drop #id's */

  public static  instanceNum:    number = 0;
  public u: number = BatchViewerComponent.instanceNum;

  /** common access to the various services */
  public services: ServiceManager       = null;

  /** the error feedback if required */
  public       errorLine: string        = '';

  /** bubble up a 'ready' event once AGGrid is ready for use. */
  public ready                          = new BehaviorSubject<boolean>(false);

  @ViewChild(BatchViewer,  {static: false})
  public viewer: BatchViewer;

  /** toggle flag for this window being the anchor (default) window for this kind of window */
  public anchored: boolean              = false;

  /** the document manager controller; where we register for anchoring etc. */
  public manager: DocumentWindowManager = null;

  public window: BatchViewerWindow      = null;

  /** the observable we use to know when some other window has taken the anchor */
  private anchorSub: Subscription;

  /* general call back for when we reload */

  public reloaded: () => void;

  /** standard constructor */
  constructor(
    services: ServiceManager
  ) {

    Logger.debug('[BatchViewerComponent] dynamically creating...');

  }

  ngAfterViewInit(): void {

    const          u: number = BatchViewerComponent.instanceNum;
    const instanceId: string = `bv_${this.u}`;

    Logger.debug(`[BatchViewerComponent] setting up id=${instanceId}...`);

    /* before we can do anything we need to establish which viewer is for this component ... */

    if (!this.viewer) {

      Logger.error(`[BatchViewerComponent] can't connect to view viewer for this instance (${u}).`);

    } else {

      Logger.debug(`[BatchViewerComponent] instance ${u} connected to viewer:`, this.viewer);
    }


    BatchViewerComponent.instanceNum++;
  }

  /** when the child view (which uses AGGrid) is ready, we tell the rest of the application we are ready. */
  public viewReady(event) {

    Logger.debug(`[BatchViewerComponent] component is ready for use.`, event);

    this.ready.next(true);
  }

  /** both parent window and this component are ready, so any final setup */
  public finalize() {

    Logger.debug(`[BatchViewerComponent] bv_${this.u} finalizing...`);

    let bvc: BatchViewerComponent = this;

    bvc.anchorSub = bvc.manager.anchorSub.subscribe((anchor: {kind: WindowType, window: DocumentWindow}) => {

      if (anchor.kind == WindowType.None) {

        return ;
      }

      if (anchor.kind != bvc.window.type) {

        /* can ignore not our kind of window */

        return ;
      }

      /* null means our group anchor was cleared, otherwise one of the windows took the anchor */

      if (anchor.window != null) {

        if (anchor.window.id() == bvc.window.id()) {

          /* can ignore self */

          return ;
        }

      }

      /* either cleared or another window took anchor, we have to set anchored to false */

      Logger.debug(`[BatchViewerComponent] bv_${this.u} cleared / other window took anchor.`);

      this.anchored = false;
    });

  }

  /** windows than can act as an anchor (default) window for their group/kind can "drop anchor" */
  public dropAnchor() {

    if (this.anchored == true) {

      return;
    }

    Logger.debug(`[BatchViewerComponent] bv_${this.u} dropping anchor`);

    /* tell the doc manager we're the default window of this kind */

    this.manager.dropAnchor(WindowType.BatchViewer, this.window)
    this.anchored = true;
  }

  /** opposite of dropping anchor, group/kind of windows will not have an anchor unitl another one is dropped. */
  public raiseAnchor() {

    if (this.anchored == false) {

      return;
    }

    /* tell the doc manager there is no default window of this kind */

    Logger.debug(`[BatchViewerComponent] bv_${this.u} raising anchor`);

    this.manager.raiseAnchor(WindowType.BatchViewer);

    this.anchored = false;
  }

  public toggleAnchor() {

    if (this.anchored == true) {

      this.raiseAnchor();

    } else {

      this.dropAnchor();
    }

  }

  /** check for geometry updates and update children as needed */
  public resize() {

    /*

    TODO:

     */
  }

  /** update the view to this batch */
  public refocus(meta: BatchViewerMetadata) {

    Logger.debug(`[BatchViewerComponent] bv_${this.u} refocusing: `, meta);

    this.viewer.refocus(meta);
  }

  /** clean up when closing the window */
  public close() {

    if (this.viewer === null) {

      return ;
    }

    Logger.debug('[BatchViewerComponent] component is closing.');

    this.viewer.close();
  }


}
